import { getCookieExpiresInDay } from '@news-mono/component-library'
import {
    BannerEvent,
    DataLayerEventName,
    storeCookie,
} from '@news-mono/web-common'

export const TN_USER_SURVEY_COOKIE_NAME = 'theNightlyUserFeedbackSurvey'
export const surveyBannerFeatureFlag = 'display-survey-banner'

const surveyLink = 'https://thenightly.com.au/usersurvey'
const privacyPolicyLink = 'https://sevenwestmedia.com.au/privacy-policies'

export interface TNUserSurveyHelperBreachModalCookie {
    expiresAt: Date
}

const storeUserSurveyCookie = (days: number) => {
    const expiresAt = getCookieExpiresInDay(days)

    const cookieValue: TNUserSurveyHelperBreachModalCookie = {
        expiresAt,
    }

    storeCookie(TN_USER_SURVEY_COOKIE_NAME, cookieValue, { expires: expiresAt })
}

const handleSurveyLinkClick = (
    userId: string,
    closeHandler: () => void,
    onEvent?: (event: BannerEvent) => void,
) => {
    storeUserSurveyCookie(7)
    window.open(surveyLink, '_blank')

    closeHandler()

    if (onEvent) {
        onEvent({
            type: DataLayerEventName.surveyBannerLinkClick,
            originator: 'StickyAccountBanner',
            payload: {
                userId,
            },
        })
    }
}

const handlePrivacyPolicyLinkClick = () => {
    window.open(privacyPolicyLink, '_blank')
}

export const getSurveyLinks = (
    userId: string,
    closeHandler: () => void,
    onEvent?: (event: BannerEvent) => void,
) => {
    return [
        {
            linkText: 'Take our survey',
            onLinkClick: () =>
                handleSurveyLinkClick(userId, closeHandler, onEvent),
        },
        {
            linkText: 'Privacy policy',
            onLinkClick: handlePrivacyPolicyLinkClick,
        },
    ]
}

export const viewSurveyBannerEvent = (
    userId: string,
    onEvent?: (event: BannerEvent) => void,
) => {
    if (onEvent) {
        onEvent({
            type: DataLayerEventName.surveyBannerViewed,
            originator: 'StickyAccountBanner',
            payload: {
                userId,
            },
        })
    }
}

export const handleDismissSurveyBanner = (
    userId: string,
    onEvent?: (event: BannerEvent) => void,
) => {
    storeUserSurveyCookie(1)
    if (onEvent) {
        onEvent({
            type: DataLayerEventName.surveyBannerDismissed,
            originator: 'StickyAccountBanner',
            payload: {
                userId,
            },
        })
    }
}

export const userSurveyMessages = [
    'We need your feedback!',
    'Help us improve The Nightly',
]
